module.exports = __webpack_public_path__ + "media/prepaid-cards/prepaid-6000-with-gift-094ad333.png";